module.exports = __webpack_public_path__ + "static/media/KML.b7a09f14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/KML.svg
// module id = 246
// module chunks = 0